<script>
import {Bar, mixins} from 'vue-chartjs'
import 'chartjs-plugin-labels';

const money = value => '$' + Number(value || 0).toLocaleString('es-AR')

export default {
  name: "AgenciaObjetivoDashboardChart",
  extends: Bar,
  mixins: [mixins.reactiveProp],
  props: {
    items: {type: Array, default: () => []}
  },
  computed: {
    chartPayload() {
      return {
        labels: this.items.map(i => i.nombre),
        datasets: [
          {
            label: 'Objetivo',
            data: this.items.map(i => i.mostrarObjetivo ? i.objetivo : null),
            backgroundColor: 'blue'
          },
          {
            label: 'Recaudado',
            data: this.items.map(i => i.recaudado),
            backgroundColor: 'teal'
          }
        ]
      }
    },
    options() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {position: 'bottom'},
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              const dataset = data.datasets[tooltipItem.datasetIndex]
              return `${dataset.label}: ${money(tooltipItem.yLabel)}`
            }
          }
        },
        plugins: {
          labels: {
            render: () => ''
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              callback: value => money(value)
            }
          }]
        }
      }
    }
  },
  watch: {
    items() {
      this.renderChart(this.chartPayload, this.options)
    }
  },
  mounted() {
    this.renderChart(this.chartPayload, this.options)
  }
}
</script>
